import Vue from "vue";
import Vuex from "vuex";

import modules from "@/store/modules";

import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// import * as L from "leaflet";

Vue.use(Vuex);

// localStorage initialization and loading
var initialBreadcrumbsOpened = window.localStorage.getItem(
	"store.state.breadcrumbsOpened"
);
if (initialBreadcrumbsOpened === null) {
	initialBreadcrumbsOpened = true;
} else {
	initialBreadcrumbsOpened = JSON.parse(initialBreadcrumbsOpened);
}

export default new Vuex.Store({
	modules,
	state: {
		// TODO: refactor MQTT stuff to its own store module
		toasts: [],
		credentials: {
			mqtt: {}
		},
		mqtt: {
			subscriptions: {}
		},
		map: {
			tileProviders: [
				{
					name: "TFM OpenStreetMap",
					visible: true,
					url: "https://tilesvr.terraformmanager.net/{z}/{x}/{y}.png",
					attribution:
						"&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a>"
				},
				{
					name: "Google Satellite",
					visible: false,
					url: "https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
					attribution: "Map data &copy;2018 Google",
					options: {
						subdomains: ["mt0", "mt1", "mt2", "mt3"]
					}
				},
				{
					name: "OSM",
					url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
					attribution:
						'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
					variants: {
						Mapnik: {},
						BlackAndWhite: {
							url: "http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
						},
						DE: {
							url:
								"http://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png"
						},
						HOT: {
							url: "http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
							attribution:
								'{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank" rel="noopener noreferrer" >Humanitarian OpenStreetMap Team</a>'
						}
					}
				}
			],
			zoom: 7,
			center: { lat: 43.54456658436357, lng: -83.9959716796875 }
		},
		breadcrumbsOpened: initialBreadcrumbsOpened,
		apiUrl:
			process.env.NODE_ENV === "production" ? "" : process.env.API_URL || "",
		user: {
			username: "",
			roles: [],
			features: [],
			labelMappings: {},
			profileAttributes: {},
			dashboard: {
				config: {
					reloadIntervalMilliseconds: 300000,
					widgets: [
						{
							widgetType: "TS_STATUS",
							displayName: "Total Stations Status",
							config: {
								backgroundColor: "#ff8",
								isDisplay: true
							}
						},
						{
							widgetType: "RSU_STATUS",
							displayName: "Roadside Units Status",
							config: {
								backgroundColor: "#ff8",
								isDisplay: true
							}
						},
						{
							widgetType: "TSC_STATUS",
							displayName: "Traffic Signal Controllers Status",
							config: {
								backgroundColor: "#ff8",
								isDisplay: true
							}
						},
						{
							widgetType: "ESS_STATUS",
							displayName: "Environmental Sensor Stations Status",
							config: {
								backgroundColor: "#ff8",
								isDisplay: true
							}
						}
					]
				}
			}
		},
		client: {
			linkUrl: "",
			logoImageUrl: "",
			name: ""
		},
		mqttCredentials: {},
		isDebug: process.env.NODE_ENV !== "production"
	},
	getters,
	mutations,
	actions
});
